<template>
  <div>
    <cards
      :id="order.client.id"
      @input="changeCard"
      v-model="order.card_id"
      :card="order.card"
    />
    <div class="row">
      <div class="col-12 col-md-6">
        <informator
          title="Категория"
          titleKey="cateogry"
          v-model="data.preliminary_category"
          :partner="partner"
          link="get-preliminary-category"
        />
      </div>

      <div class="col-12 col-md-6">
        <informator
          title="Семейное положение"
          titleKey="family_status"
          v-model="data.family_status"
          :partner="partner"
          link="get-family-statuses"
        />
      </div>
      <div class="col-12 col-md-6">
        <label>{{ "children_count" | setText("Количество детей") }}</label>
        <select class="form-control" v-model="data.children_count">
          <option :value="k" v-for="(i, k) in 11" :key="k">
            {{ k }}
          </option>
        </select>
      </div>

      <div class="col-5 col-md-4">
        <fg-input
          :type="`text`"
          :label="`Серия паспорта`"
          :labelKey="`passport_series`"
          v-model="data.passport_series"
        ></fg-input>
      </div>
      <div class="col-7 col-md-8">
        <fg-input
          :type="`number`"
          :label="`Номер паспорта`"
          :labelKey="`passport_number`"
          v-model="data.passport_number"
        ></fg-input>
      </div>
      <div class="col-12 col-md-12">
        <fg-input
          v-mask="`##############`"
          :type="`number`"
          :label="`ПИНФЛ`"
          :labelKey="`pinfl`"
          v-model="data.pinfl"
        ></fg-input>
      </div>
      <div class="col-12 col-md-12">
        <fg-input
          :type="`date`"
          :label="`Дата рождения`"
          :labelKey="`birthday`"
          v-model="data.date_of_birth"
        ></fg-input>
      </div>

      <div class="col-12 col-md-6">
        <label>{{ "experience" | setText("Стаж работы") }}</label>
        <select class="form-control" v-model="data.experience">
          <option :value="k" v-for="(i, k) in 61" :key="k">
            {{ k }}
          </option>
        </select>
      </div>
      <div class="col-6 col-md-6">
        <fg-input
          :type="`number`"
          :label="`Заработная плата`"
          :labelKey="`salary`"
          v-model.number="data.salary"
        ></fg-input>
      </div>
      <div class="col-12 col-md-12">
        <label>{{
          "first_payment_date"
            | setText(
              "День снятия денежных средств, сумма по погашению задолжности будет сниматься каждый месяц в это число"
            )
        }}</label>
        <select class="form-control" v-model="data.first_payment_date">
          <option :value="k" v-for="(i, k) in 23" :key="k">
            {{ i }}
          </option>
        </select>
      </div>
    </div>

    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {
    "order.card": {
      handler: function (val) {
        try {
          this.data.card_number = val.card_number
            ? val.card_number.replace(/\s+/g, "")
            : "";

          this.data.card_expiry = val.exp ? val.exp.replace("/", "") : "";
        } catch (error) {}
      },
      deep: true,
    },
  },
  components: {
    informator: () => import("./Informator"),
    Cards: () => import("@/components/Item/Order/Client/Cards"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    this.data.passport_series = this.order.client.passport_number
      ? this.order.client.passport_number.substring(0, 2)
      : null;
    this.data.passport_number = this.order.client.passport_number
      ? this.order.client.passport_number.substring(2)
      : null;

    this.data.pinfl = this.order.client.PINFL;
    this.data.date_of_birth = this.order.client.birthday;
    this.data.phone_number = this.order.client.phone;
    this.data.street = this.order.client.passport_address;
  },
  methods: {
    async changeCard(val) {
      await this.updateOrder({ card_id: val });
    },
    send() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}pre-scoring`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: this.data,
      })
        .then((response) => {
          if (response.data) {
            console.log(response.data);
            //this.$emit("setStep", "confirm-pre-scoring");
            this.$emit("setStep", "send-data");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      data: {
        phone_number: null,
        pinfl: null,
        passport_series: null,
        passport_number: null,
        date_of_birth: null,
        card_expiry: "0128",
        card_number: "9860600430357308",
        salary: 20000000,
        children_count: 2,
        experience: 2,
        family_status: {
          guid: "0",
          label: "Женат/Замужем",
        },
        preliminary_category: {
          guid: "b9f84642-5483-11ed-b823-c550a0567f26",
          label: "Смартфоны",
        },
        first_payment_date: 2,
      },
    };
  },
};
</script>

